<template>
    <div id="copyright-bar">
        <p style="font-size: 12px">
            <b>{{ $t("copyright.built-by") }}</b> <a href="https://sportips.fr" target="_blank"><img
                    src="https://sportips.fr/ressources/logo_menu.png" style="display: inline; width: 80px" /></a>
            <br/>
            Hosted on SCALEWAY
        </p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>